import { Modal } from "antd";
import LoginPage from "../../../LoginPage";
import "./index.scss";
import { useEffect } from "react";
import { COOKIE_NAME_REDIRECT_URL, setCookie } from "../../../../services/clientService";

const SignupModal = props => {
    const { setSignupModalOpen, signupModalOpen } = props;
    useEffect(() => {
        if (signupModalOpen)
            setCookie(COOKIE_NAME_REDIRECT_URL, window.location.href)
    }, [signupModalOpen])
    return (
        <Modal open={signupModalOpen} footer={null} onCancel={() => setSignupModalOpen(false)} className="signup-modal">
            <div className="modal-title">Don’t lose your hard work!</div>
            <div className="modal-desc">Sign up to save your progress.</div>
            <LoginPage flow="resume-builder" />
        </Modal>
    )
}

export default SignupModal;